(function () {
  'use strict';

  /* ============================================================
     GSAP — wait for it to load, then init animations
     ============================================================ */
  function waitForGSAP(cb) {
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      cb();
    } else {
      setTimeout(function () { waitForGSAP(cb); }, 80);
    }
  }

  /* ============================================================
     STICKY HEADER GLASSMORPHISM
     ============================================================ */
  function initStickyHeader() {
    var header = document.getElementById('header-component');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList.toggle('tr-header--scrolled', window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ============================================================
     WHATSAPP FLOAT
     ============================================================ */
  function initWhatsApp() {
    if (document.querySelector('.tr-whatsapp-float')) return;
    var btn = document.createElement('a');
    btn.className = 'tr-whatsapp-float';
    btn.setAttribute('aria-label', 'Contactar por WhatsApp');
    btn.target = '_blank';
    btn.rel = 'noopener noreferrer';
    var h1 = document.querySelector('.product-details h1, .product-information h1');
    var title = h1 ? h1.textContent.trim() : '';
    var url = window.location.href;
    var msg = title
      ? 'Hola, estoy interesado en: ' + title + ' — ' + url
      : 'Hola, tengo una consulta: ' + url;
    btn.href = 'https://wa.me/59169250680?text=' + encodeURIComponent(msg);
    btn.innerHTML =
      '<svg viewBox="0 0 32 32" width="22" height="22" fill="white"><path d="M16.004 0C7.165 0 0 7.163 0 16.001c0 2.822.736 5.58 2.137 8.012L.073 32l8.19-2.147A15.95 15.95 0 0016.004 32C24.838 32 32 24.837 32 16.001 32 7.163 24.838 0 16.004 0zm0 29.306a13.27 13.27 0 01-6.762-1.852l-.486-.288-5.03 1.319 1.342-4.9-.316-.502A13.21 13.21 0 012.695 16C2.695 8.651 8.652 2.694 16.004 2.694c7.35 0 13.302 5.957 13.302 13.307 0 7.35-5.952 13.305-13.302 13.305zm7.296-9.958c-.4-.2-2.366-1.168-2.733-1.3-.367-.134-.634-.2-.9.2-.268.4-1.034 1.3-1.268 1.568-.233.268-.467.3-.867.1-.4-.2-1.687-.622-3.214-1.982-1.188-1.06-1.99-2.368-2.223-2.768-.233-.4-.025-.616.175-.815.18-.18.4-.467.6-.7.2-.234.267-.4.4-.668.134-.268.067-.5-.033-.7-.1-.2-.9-2.168-1.234-2.968-.324-.778-.654-.672-.9-.685l-.766-.013c-.267 0-.7.1-1.067.5-.367.4-1.4 1.368-1.4 3.336 0 1.968 1.434 3.868 1.634 4.136.2.267 2.822 4.31 6.838 6.042.955.413 1.7.659 2.282.844.959.305 1.832.262 2.522.159.77-.115 2.367-.968 2.7-1.902.334-.935.334-1.735.234-1.902-.1-.168-.367-.268-.767-.468z"/></svg><span class="tr-whatsapp-float__label">Consultar</span>';
    document.body.appendChild(btn);

    /* --- GSAP animations --- */
    function animateWap() {
      if (typeof gsap === 'undefined') { setTimeout(animateWap, 80); return; }

      var svg = btn.querySelector('svg');

      /* 1. Entrada: fade + slide suave */
      gsap.set(btn, { y: 32, opacity: 0 });
      gsap.to(btn, {
        y: 0, opacity: 1,
        duration: 0.7,
        delay: 1.6,
        ease: 'power3.out',
        onComplete: function() {
          btn.classList.add('tr-whatsapp-float--visible');
          scheduleShake();
        }
      });

      /* 2. Sacudida de atención cada 8s */
      function doShake() {
        gsap.timeline()
          .to(btn, { x: -6, duration: 0.07, ease: 'none' })
          .to(btn, { x:  6, duration: 0.07, ease: 'none' })
          .to(btn, { x: -5, duration: 0.07, ease: 'none' })
          .to(btn, { x:  5, duration: 0.07, ease: 'none' })
          .to(btn, { x: -3, duration: 0.06, ease: 'none' })
          .to(btn, { x:  0, duration: 0.06, ease: 'power2.out' })
          .call(scheduleShake);
      }

      function scheduleShake() {
        gsap.delayedCall(8, doShake);
      }

      /* 3. Hover: escala + rotación del ícono */
      btn.addEventListener('mouseenter', function() {
        gsap.to(btn, { scale: 1.12, boxShadow: '0 8px 32px rgba(37,211,102,0.65)', duration: 0.25, ease: 'power2.out' });
        if (svg) gsap.to(svg, { rotation: 15, duration: 0.3, ease: 'power2.out' });
      });
      btn.addEventListener('mouseleave', function() {
        gsap.to(btn, { scale: 1, boxShadow: '0 4px 24px rgba(37,211,102,0.45)', duration: 0.35, ease: 'power2.out' });
        if (svg) gsap.to(svg, { rotation: 0, duration: 0.3, ease: 'power2.out' });
      });
    }

    animateWap();
  }

  /* ============================================================
     GSAP SCROLL ANIMATIONS
     ============================================================ */
  function initGSAPAnimations() {
    /* Hero text */
    var heroTexts = document.querySelectorAll(
      '.hero__content .text-block, .slideshow__slide .text-block, .hero__content .button-group'
    );
    heroTexts.forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', delay: 0.15 }
      );
    });

    /* Features strip cards — staggered */
    gsap.fromTo('.tr-feature',
      { opacity: 0, y: 40 },
      {
        opacity: 1, y: 0,
        duration: 0.65,
        ease: 'power3.out',
        stagger: 0.12,
        scrollTrigger: {
          trigger: '.tr-features-strip',
          start: 'top 85%',
        }
      }
    );

    /* Category cards */
    var catCards = document.querySelectorAll(
      'collection-links-component .block-container, [data-testid*="collection-links"] .block-container'
    );
    if (catCards.length) {
      gsap.fromTo(catCards,
        { opacity: 0, y: 50, scale: 0.96 },
        {
          opacity: 1, y: 0, scale: 1,
          duration: 0.7,
          ease: 'power3.out',
          stagger: 0.1,
          scrollTrigger: {
            trigger: catCards[0].closest('collection-links-component') || catCards[0],
            start: 'top 80%',
          }
        }
      );
    }

    /* Media-with-content / Más vendido */
    var mediaContent = document.querySelector('[data-testid="media-with-content"]');
    if (mediaContent) {
      gsap.fromTo(mediaContent,
        { opacity: 0, y: 36 },
        {
          opacity: 1, y: 0,
          duration: 0.75,
          ease: 'power3.out',
          scrollTrigger: { trigger: mediaContent, start: 'top 80%' }
        }
      );
      /* Children stagger */
      gsap.fromTo(mediaContent.querySelectorAll('h1, h2, h3, p, .button, a'),
        { opacity: 0, y: 20 },
        {
          opacity: 1, y: 0,
          duration: 0.55,
          ease: 'power2.out',
          stagger: 0.08,
          scrollTrigger: { trigger: mediaContent, start: 'top 78%' }
        }
      );
    }

    /* Product cards — fade up staggered */
    var productCards = document.querySelectorAll('.resource-list__item, .product-grid__item');
    if (productCards.length) {
      gsap.fromTo(productCards,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0,
          duration: 0.6,
          ease: 'power3.out',
          stagger: 0.07,
          scrollTrigger: {
            trigger: productCards[0].closest('ul, .resource-list') || productCards[0],
            start: 'top 82%',
          }
        }
      );
    }

    /* Section titles */
    var titles = document.querySelectorAll(
      '.section-resource-list__header, [data-testid*="collection-links"] > .text-block h2'
    );
    titles.forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, x: -24 },
        {
          opacity: 1, x: 0,
          duration: 0.6,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 86%' }
        }
      );
    });

    /* Marquee brand section */
    var marquee = document.querySelector('marquee-component');
    if (marquee) {
      gsap.fromTo(marquee,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.8,
          scrollTrigger: { trigger: marquee, start: 'top 88%' }
        }
      );
    }

    /* Footer */
    var footer = document.querySelector('.shopify-section-group-footer-group');
    if (footer) {
      gsap.fromTo(footer.querySelectorAll('.footer-content > *'),
        { opacity: 0, y: 24 },
        {
          opacity: 1, y: 0,
          duration: 0.55,
          ease: 'power2.out',
          stagger: 0.1,
          scrollTrigger: { trigger: footer, start: 'top 90%' }
        }
      );
    }
  }

  /* ============================================================
     CARD RIPPLE on click
     ============================================================ */
  function initCardRipple() {
    var cards = document.querySelectorAll(
      'collection-links-component .block-container, [data-testid*="collection-links"] .block-container'
    );
    cards.forEach(function (card) {
      card.style.position = 'relative';
      card.style.overflow = 'hidden';
      card.addEventListener('click', function (e) {
        var ripple = document.createElement('span');
        var rect = card.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        ripple.style.cssText =
          'position:absolute;border-radius:50%;background:rgba(255,255,255,0.3);' +
          'width:' + size + 'px;height:' + size + 'px;' +
          'left:' + (e.clientX - rect.left - size / 2) + 'px;' +
          'top:' + (e.clientY - rect.top - size / 2) + 'px;' +
          'transform:scale(0);animation:tr-ripple 0.55s ease-out forwards;pointer-events:none;z-index:10;';
        card.appendChild(ripple);
        setTimeout(function () { ripple.remove(); }, 600);
      });
    });
  }

  /* ============================================================
     STOCK BANNER
     ============================================================ */
  function initStockBanner() {
    var btn = document.querySelector('.product-information [name="add"][type="submit"]');
    if (!btn) return;
    var wrap = btn.closest('.product-form-buttons') || btn.parentElement;
    var banner = document.createElement('div');
    banner.className = 'tr-stock-banner';
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
      banner.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg><span>Agotado — Consultá por WhatsApp</span>';
      banner.classList.add('tr-stock-banner--soldout');
    } else {
      banner.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg><span>Alta demanda · Pocas unidades</span>';
    }
    wrap.parentElement.insertBefore(banner, wrap.nextSibling);
  }

  /* ============================================================
     GALLERY ZOOM
     ============================================================ */
  function initGalleryZoom() {
    var img = document.querySelector('.product-information .product-media__image');
    if (!img) return;
    var container = img.closest('.product-media-container');
    if (!container) return;
    var lens = document.createElement('div');
    lens.className = 'tr-zoom-lens';
    container.style.position = 'relative';
    container.addEventListener('mouseenter', function () { container.appendChild(lens); lens.style.display = 'block'; });
    container.addEventListener('mouseleave', function () {
      lens.style.display = 'none';
      img.style.transformOrigin = 'center center';
      img.style.transform = '';
    });
    container.addEventListener('mousemove', function (e) {
      var r = container.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      img.style.transform = 'scale(1.8)';
      lens.style.left = (e.clientX - r.left - 40) + 'px';
      lens.style.top = (e.clientY - r.top - 40) + 'px';
    });
  }

  /* ============================================================
     PRICE POP
     ============================================================ */
  function initPricePop() {
    var price = document.querySelector('.product-information .price__regular .price');
    if (!price || !window.gsap) return;
    ScrollTrigger.create({
      trigger: price,
      start: 'top 85%',
      once: true,
      onEnter: function () {
        gsap.fromTo(price, { scale: 0.9, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.4, ease: 'back.out(1.5)' });
      }
    });
  }

  /* ============================================================
     ACTIVE NAV LINK
     ============================================================ */
  function initActiveMenu() {
    var path = window.location.pathname;
    document.querySelectorAll('#header-component .menu-list__link').forEach(function (link) {
      if (link.getAttribute('href') === path) {
        link.style.color = 'var(--tr-red)';
      }
    });
  }

  /* ============================================================
     MARQUEE — keyboard accessibility
     ============================================================ */
  function initMarquee() {
    var marquee = document.querySelector('marquee-component');
    if (!marquee) return;
    marquee.setAttribute('tabindex', '0');
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initStickyHeader();
    initWhatsApp();
    initStockBanner();
    initGalleryZoom();
    initActiveMenu();
    initMarquee();
    initCardRipple();

    /* GSAP animations after lib loads */
    waitForGSAP(function () {
      initGSAPAnimations();
      initPricePop();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
